import { NO_IMAGE } from 'chemistry'

const PRIMARY_IMAGE_TYPE = 'PRIMARY'
const CORRECT_SIZE = '424'
const THUMB_SIZE = '54'
const DEFAULT_VIDEO_THUMB = 'https://d2fb1ew6v6wv87.cloudfront.net/products/common/video-thumb.png'
const pimImage = /s\d{2,}\/origin/
const imageScalerFormat = /\/\d{4,}-\d{2,}-\d{2,}\.\w+/
const imageFormat = /.+\.(jpeg|jpg|png|webp|tiff|tif|heif|raw|tile|gif|svg)$/
const videoFormat = /.+\.(mp4|ogg)$/

const pimdamImagePathProcessor = path =>
  path.replace(/s3.eu-west-1/, 's3-website-eu-west-1').replace('/origin', `/${CORRECT_SIZE}x${CORRECT_SIZE}/origin`)

const processVideoThumb = thumb => {
  if (thumb) {
    return thumb
      .replace(/s3.eu-west-1/, 's3-website-eu-west-1')
      .replace('/origin', `/${THUMB_SIZE}x${THUMB_SIZE}/origin`)
  }
  return DEFAULT_VIDEO_THUMB.replace('/common', `/common/${THUMB_SIZE}x${THUMB_SIZE}`)
}

const hybrisImagePathProcessor = path => {
  const [idImgAnPath, , widthAndFileExtension] = path.split('-')
  const [, fileExtension] = widthAndFileExtension.split('.')
  return `${idImgAnPath}-${CORRECT_SIZE}-${CORRECT_SIZE}.${fileExtension}`
}

const isPathHasPimDamFormat = path => pimImage.test(path.toLowerCase())

export const convertImagePathToFitImageSize = path => {
  if (!path) return path
  const webpPath = path.replace(/\.(\w)+$/, '.webp')

  if (isPathHasPimDamFormat(webpPath)) {
    return pimdamImagePathProcessor(webpPath)
  }

  return hybrisImagePathProcessor(webpPath)
}

const getEmptyImageStructure = () => ({ src: NO_IMAGE, title: '' })

// For Safari on Catalina, old iOs, do not support webp :(
const getImgFallbackSrc = src => src.replace(/\.webp$/, '.jpeg')

const isWebpSupported = () => {
  return (
    typeof global.document === 'undefined' ||
    (typeof global.document !== 'undefined' &&
      parseInt(global.document?.createElement('canvas')?.toDataURL('image/webp')?.indexOf('data:image/webp'), 10) === 0)
  )
}

const getImageSelector = ({ url, imageType, altText, withWebp }) => {
  const path = convertImagePathToFitImageSize(url)
  const src = withWebp ? path : getImgFallbackSrc(path)
  return {
    src,
    imageType,
    title: altText,
    thumb: src?.replace('424x424', '54x54')
  }
}

const getVideoSelector = ({ format, url, type, sequence, thumb }) => ({
  type,
  sequence,
  video: {
    source: [
      {
        src: url,
        type: format || `video/${url.split('.').pop()}`
      }
    ],
    attributes: {
      preload: false,
      controls: true
    }
  },
  thumb: processVideoThumb(thumb)
})

const isImageValid = ({ url }) => imageFormat.test(url) && (isPathHasPimDamFormat(url) || imageScalerFormat.test(url))
const isValidVideoAsset = ({ url, type }) => type === 'VIDEO' && videoFormat.test(url)

const isImagePrimary = image => image.imageType === PRIMARY_IMAGE_TYPE

export default gallery => {
  const isGalleryEmpty = !gallery || !gallery.length

  if (isGalleryEmpty) {
    return new Array(getEmptyImageStructure())
  }

  const listOfValidVideos = gallery.filter(isValidVideoAsset)
  const listOfValidImages = gallery.filter(isImageValid)

  const selectedImages = listOfValidImages.map(img => getImageSelector({ ...img, withWebp: isWebpSupported() }))
  const selectedVideos = listOfValidVideos.map(video => getVideoSelector(video))

  if (!selectedImages || !selectedImages.length) {
    return new Array(getEmptyImageStructure())
  }

  const properImageList = selectedImages.filter(img => !isImagePrimary(img)) || []
  const primaryImage = selectedImages.filter(isImagePrimary)[0]
  if (primaryImage) properImageList.unshift(primaryImage)

  return [...properImageList, ...selectedVideos]
}
